import { useCallback, useEffect, useState } from 'react';

export const SIDEBAR_STORAGE_KEY = 'gym_admin_sidebar_open';

/**
 * Whether the sidebar is expanded, remembered across reloads.
 *
 * `SidebarProvider` writes a `sidebar_state` cookie of its own, but nothing
 * reads it back — upstream that is for a server render to pick up, and this is a
 * SPA. So the state is driven through the provider's controlled props from here
 * instead, and kept where the rest of the admin keeps its preferences.
 *
 * Anything other than a stored "false" reads as expanded, so a first visit — or
 * a value someone else wrote — opens the sidebar rather than hiding the menu.
 */
export function useSidebarOpen(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => localStorage.getItem(SIDEBAR_STORAGE_KEY) !== 'false');

  useEffect(() => {
    localStorage.setItem(SIDEBAR_STORAGE_KEY, String(open));
  }, [open]);

  return [open, useCallback((next: boolean) => setOpen(next), [])];
}
